// removed by extract-text-webpack-plugin
module.exports = {"baseUnitValue":"8px","button":"_3QtOZrUricXW7xFEg1S2hr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/loginForm.css
// module id = 1067
// module chunks = 0